import { root } from "./config.js"
import { loadWeaponList } from "./loadWeaponList.js"
import { header } from "./views/header.js"
import { weaponListHeader } from "./views/weaponListHeader.js"
import ruLang from 'url:./langs/ru.js';

export const logout = () => {
    const logoutBtn = document.querySelector('.header-logout')

    logoutBtn.addEventListener('click', () => {
        localStorage.removeItem('token')
        window.location.href = '/'
    })
}

export const getLocation = () => {
    const url = decodeURI(window.location.pathname).split('/')[1];
    return url
}

export const setLocation = (url, title = 'Гладкоствольное оружие') => {
    // window.location.pathname = '/';
    const newurl = window.location.protocol + "//" + window.location.host + '/' + url;
    document.title = title;
    window.history.pushState({ path: newurl }, title, newurl);
    localStorage.setItem('route', newurl)
}

export const getLocationURL = () => {
    const route = localStorage.getItem('route')?.split('/');
    if(!route){
        return
    }
    return route[route.length - 1]
}

export const addLoader = (parentElem) => {
    const LoadContainer = `
        <div class="loader">
            <svg class="circular-loader" viewBox="25 25 50 50">
                <circle class="loader-path" cx="50" cy="50" r="20" fill="none"></circle>
            </svg>
        </div>
    `;
    parentElem.insertAdjacentHTML('afterbegin', LoadContainer)
}

export const removeLoader = () => {
    document.querySelector('.loader').remove()
}

export const initTynymce = async () => {
    await tinymce.init({
        selector: '#weapon-text',
        statusbar: false,
        menubar: false,
        height: 900,
        language: 'ru',
        language_url: ruLang,
        plugins: 'lists',
        toolbar: 'undo redo | blocks | ' + 'bold italic backcolor | alignleft aligncenter ' + 'alignright alignjustify | bullist numlist outdent indent | ' + 'removeformat',
    });
}

export const menuNavigation = () => {
    const menuLinks = document.querySelectorAll('.header-nav__item');

    menuLinks.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault()
            const path = link.href.split('/')
            root.innerHTML = '';
            setLocation(path[path.length - 1], link.textContent)
            header()
            weaponListHeader()
            loadWeaponList()
            tinymce.remove()
        })
    })
}

